import * as React from 'react';
import classNames from 'classnames';
import { Nav, NavItem, NavLink, TabContent } from 'reactstrap';
import { ProjectSelect, ProjectNewForm } from 'src/app/Partials';
import { ProjectsDispatcher } from 'src/app/Container';

import './ConfigurationProject.page.scss';
import TabPane from 'reactstrap/lib/TabPane';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ConfigurationProject.messages';

export interface ConfigurationProjectPageProps {
  projects: GlobalPrivateState['projects'];
}

enum TabIDs {
  EXISTING = 'EXISTING',
  NEW = 'NEW',
}

export interface ConfigurationProjectPageState {
  activeTab: TabIDs;
}

export class ConfigurationProjectPageComponent extends React.Component<ConfigurationProjectPageProps, ConfigurationProjectPageState > {
  constructor(props: ConfigurationProjectPageProps) {
    super(props);
    this.state = {
      activeTab: TabIDs.EXISTING,
    };
  }

  componentDidUpdate(prevProps: ConfigurationProjectPageProps) {
    const projects = this.props.projects.result;
    const prevProjects = prevProps.projects.result;
    const hasProjects = this.hasProjects();
    const prevHasProjects = this.hasProjects(prevProps);

    if (!hasProjects && this.state.activeTab !== TabIDs.NEW) {
      this.setState({
        activeTab: TabIDs.NEW,
      });
    }
    if (
      (projects && projects.length) !== (prevProjects && prevProjects.length) || 
      hasProjects && !prevHasProjects
      ) {
      this.setState({
        activeTab: TabIDs.EXISTING,
      });
    }
  }

  public render() {
    const { activeTab } = this.state;
    const hasProjects = this.hasProjects();
    return (     
      <div className="page-configuration-project d-flex justify-content-center align-items-center">
        <ProjectsDispatcher />
        <div className="container">
          <div className="row mb-5">
            <div className="col-12 col-md-8 offset-md-2">
              <h3 className="text-center mb-0">
                <FormattedMessage {...MESSAGES.configurationProjectHeadline} />
              </h3>
            </div>
          </div>
          <div className="row mb-5">
            <div className="col-12 col-md-8 offset-md-2">
              <Nav tabs={true} className="border-0 d-table w-100 text-center">
                <NavItem className="border-0 d-table-cell">
                  {hasProjects && (
                    <NavLink                        
                      className={classNames('rounded-0 border-0 d-block p-3', { active: activeTab === TabIDs.EXISTING })}
                      onClick={() => this.toggle(TabIDs.EXISTING)}
                    >
                      <FormattedMessage {...MESSAGES.configurationProjectTabExisting} />
                    </NavLink>
                  )}
                </NavItem>
                <NavItem className="border-0 d-table-cell">
                  <NavLink                        
                    className={classNames('rounded-0 border-0 d-block p-3', { active: activeTab === TabIDs.NEW })}
                    onClick={() => this.toggle(TabIDs.NEW)}
                  >
                    <FormattedMessage {...MESSAGES.configurationProjectTabNew} />
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-8 offset-md-2">
              <TabContent activeTab={activeTab} className="w-100">
                {hasProjects && (
                  <TabPane tabId={TabIDs.EXISTING} className={classNames({'active': activeTab === TabIDs.EXISTING })}>
                    <ProjectSelect />
                  </TabPane>
                )}
                <TabPane tabId={TabIDs.NEW} className={classNames({'active': activeTab === TabIDs.NEW })}>
                  <ProjectNewForm forConfiguration={true} />
                </TabPane>
              </TabContent>
            </div>
          </div>
        </div>
      </div>
    );
  }

  private toggle(tab: TabIDs) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  private hasProjects(props?: ConfigurationProjectPageProps): boolean {
    const { projects } = props || this.props;

    if (!projects) {
      return false;
    }

    if (!projects.result) {
      return false;
    }

    return projects.result.length > 0 ? true : false;
  }
}

export const ConfigurationProjectPage = connect((state: GlobalPrivateState) => ({
  projects: state.projects,
}))(ConfigurationProjectPageComponent);

export default ConfigurationProjectPage;
